var styles = {"radioInput":"styles_radio-input__4pJPe","radioListContainer":"styles_radio-list-container__2ebCB","noSpacing":"styles_no-spacing__6E59H","compactSpacing":"styles_compact-spacing__2IPSR","comfortableSpacing":"styles_comfortable-spacing__dSytL","looseSpacing":"styles_loose-spacing__kTIMg"};

export { styles as default };
//# sourceMappingURL=styles.css.js.map
